import { Caption, Heading } from "@shopify/polaris"
import React, { useContext } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Video } from "../Video.jsx"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"

export const Step2 = ({ randomAppNameButton }) => {
	const { t } = useTranslation()
	const { state } = useContext(GlobalStateContext)

	const KopyOnboardingVideo2 = "https://kopy.b-cdn.net/kopy-onboarding-2.webm"

	const CheckedIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1.4rem"
			height="1.4rem"
			viewBox="0 0 24 24"
		>
			<path
				fill="currentColor"
				d="M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5A3.25 3.25 0 0 0 6.25 21h11.5A3.25 3.25 0 0 0 21 17.75V6.25A3.25 3.25 0 0 0 17.75 3H6.25ZM4.5 6.25c0-.966.784-1.75 1.75-1.75h11.5c.966 0 1.75.784 1.75 1.75v11.5a1.75 1.75 0 0 1-1.75 1.75H6.25a1.75 1.75 0 0 1-1.75-1.75V6.25Zm12.78 3.03a.75.75 0 1 0-1.06-1.06l-6.223 6.216L7.78 12.22a.75.75 0 0 0-1.06 1.06l2.745 2.746a.75.75 0 0 0 1.06 0l6.754-6.745Z"
			></path>
		</svg>
	)

	const DontCheckIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1.4rem"
			height="1.4rem"
			viewBox="0 0 24 24"
		>
			<path
				fill="currentColor"
				d="M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12zm5.793-4.207a1 1 0 0 1 1.414 0L12 10.586l2.793-2.793a1 1 0 1 1 1.414 1.414L13.414 12l2.793 2.793a1 1 0 0 1-1.414 1.414L12 13.414l-2.793 2.793a1 1 0 0 1-1.414-1.414L10.586 12L7.793 9.207a1 1 0 0 1 0-1.414z"
			></path>
		</svg>
	)

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
				paddingBottom: "0.5rem",
			}}
		>
			<div style={{ width: "100%", height: "auto" }}>
				<Video videoSrc={KopyOnboardingVideo2} />
			</div>

			<h1
				style={{
					marginTop: "1rem",
					marginBottom: "1rem",
					fontSize: "1.2rem",
					fontWeight: "600",
					color: "#222",
					lineHeight: "1.1",
				}}
			>
				{t("link_store.step_2")}
			</h1>

			<p
				style={{
					marginBottom: "0.5rem",
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_2_1"
					components={{ b: <b></b>, randomAppNameButton }}
				></Trans>
			</p>
			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				{t("link_store.step_2_2")}
			</p>

			<div
				style={{
					paddingLeft: "1rem",
					display: "flex",
					flexDirection: "column",
					gap: "0.3rem",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
					}}
				>
					{CheckedIcon}
					<code>read_products</code>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
					}}
				>
					{CheckedIcon}
					<code>write_products</code>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
					}}
				>
					{CheckedIcon}
					<code>read_locales</code>
				</div>
				{state.hasValidKopyProtectSubscription && (
					<>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "0.3rem",
							}}
						>
							{CheckedIcon}
							<code>write_script_tags</code>
						</div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "0.3rem",
							}}
						>
							{CheckedIcon}
							<code>read_script_tags</code>
						</div>
					</>
				)}

				<div
					style={{
						padding: "0.5rem",
						backgroundColor: "#fff68d",
						borderRadius: "0.5rem",
						margin: "0.5rem 0rem",
					}}
				>
					<p style={{ fontSize: "0.95rem", color: "#222" }}>
						{t("link_store.step_2_2_warning")}
					</p>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
						color: "#ff0101ff",
					}}
				>
					{DontCheckIcon}
					<code>read_product_listings</code>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
						color: "#ff0101ff",
					}}
				>
					{DontCheckIcon}
					<code>write_product_listings</code>
				</div>
			</div>

			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_2_3"
					components={{ b: <b></b> }}
				></Trans>
			</p>
		</div>
	)
}
